import React, { ReactNode } from "react";
import ProgressBar from "./ProgressBar";
import { useNavigate } from "react-router-dom";
import { Button } from "src/components/ui/Button";
import { ROUTES } from "src/routes/RouteConfig";

interface OnboardingLayoutProps {
  children: ReactNode;
  currentStep: number;
  totalSteps: number;
  nextStep: () => void;
  prevStep: () => void;
  isNextDisabled?: boolean;
  nextButtonText?: string;
}

const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  children,
  currentStep,
  totalSteps,
  nextStep,
  prevStep,
  isNextDisabled = false,
  nextButtonText = "Next",
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
      <div className="w-full max-w-3xl bg-white rounded-lg shadow-md p-8">
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-white text-sm" style={{ fontWeight: '600' }}>
                {currentStep}
              </div>
              <span className="text-sm text-gray-600" style={{ fontWeight: '400' }}>Step {currentStep} of {totalSteps}</span>
            </div>
            <div className="text-sm text-gray-500" style={{ fontWeight: '400' }}>
              {Math.round((currentStep / totalSteps) * 100)}% Complete
            </div>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-6">
            <div 
              className="bg-green-500 h-2 rounded-full transition-all duration-300"
              style={{ width: `${(currentStep / totalSteps) * 100}%` }}
            ></div>
          </div>
        </div>
        <div className="mb-8">{children}</div>
        <div className="flex justify-between items-center">
          {currentStep > 1 ? (
            <button
              className="bg-gray-200 hover:bg-gray-300 text-gray-700 py-3 px-6 rounded-xl transition-colors duration-200"
              style={{ fontWeight: '500' }}
              type="button"
              onClick={prevStep}
            >
              Back
            </button>
          ) : (
            <button
              className="bg-gray-200 hover:bg-gray-300 text-gray-700 py-3 px-6 rounded-xl transition-colors duration-200"
              style={{ fontWeight: '500' }}
              type="button"
              onClick={() => navigate(ROUTES.HOME.path)}
            >
              Cancel
            </button>
          )}
          <button
            className="bg-purple-400 hover:bg-purple-500 text-white py-3 px-6 rounded-xl transition-colors duration-200"
            style={{ fontWeight: '500' }}
            type="button"
            onClick={nextStep}
            disabled={isNextDisabled}
          >
            {currentStep === totalSteps ? "Complete" : nextButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout;
